export default __webpack_public_path__ + "static/media/big-purpule-vaccine.9fff4626.svg";